/**
 * Variaveis de resposta pronta.
 *
 * Vive no kernel, e nao na web nem na api, porque as duas pontas precisam da
 * MESMA resposta: a tela decide se pode enviar, e o servidor decide se aceita.
 * Se cada lado tivesse a sua lista, a tela liberaria o que o servidor recusa —
 * ou pior, o contrario.
 *
 * ── Por que nome e nao posicao ──
 * Template da Meta usa `{{1}}`, `{{2}}` porque a Graph API exige ✅. Aqui quem
 * le e a atendente, numa lista de mensagens prontas, sem a mensagem na frente.
 * `{paciente}` se entende; `{{2}}` obriga a decorar ordem.
 */
/** O que existe de verdade no momento de responder uma conversa. */
export const VARIAVEIS = [
    { nome: 'paciente', rotulo: 'Nome do paciente', sempre: true },
    { nome: 'medico', rotulo: 'Nome do medico', sempre: true },
    { nome: 'atendente', rotulo: 'Seu nome', sempre: true },
    { nome: 'telefone', rotulo: 'Telefone do paciente', sempre: true },
    { nome: 'retorno', rotulo: 'Data da proxima consulta marcada', sempre: false },
    { nome: 'atendido', rotulo: 'Quem sera atendido na proxima consulta', sempre: false },
    { nome: 'ultima_consulta', rotulo: 'Data da ultima consulta na agenda', sempre: false },
    { nome: 'especialidade', rotulo: 'Especialidade do medico', sempre: false },
];
const NOMES = new Set(VARIAVEIS.map((v) => v.nome));
/** `{paciente}` — chaves simples, sem espaco, so letras e sublinhado. */
const MARCADOR = /\{([a-z_]+)\}/g;
/** Quais marcadores o texto usa, na ordem em que aparecem, sem repetir. */
export function variaveisUsadas(corpo) {
    const vistas = new Set();
    const saida = [];
    for (const m of corpo.matchAll(MARCADOR)) {
        const nome = m[1];
        if (vistas.has(nome))
            continue;
        vistas.add(nome);
        saida.push({ nome, desconhecida: !NOMES.has(nome) });
    }
    return saida;
}
/**
 * Troca os marcadores pelos valores.
 *
 * O que falta NAO vira string vazia: o marcador fica no texto. Apagar
 * silenciosamente produziria "seu retorno esta marcado para ." e alguem
 * enviaria isso sem perceber — o buraco visivel e o aviso.
 */
export function preencher(corpo, valores) {
    const faltando = [];
    const desconhecidas = [];
    const texto = corpo.replace(MARCADOR, (inteiro, nome) => {
        if (!NOMES.has(nome)) {
            if (!desconhecidas.includes(nome))
                desconhecidas.push(nome);
            return inteiro;
        }
        const valor = valores[nome];
        if (valor === undefined || valor === null || valor.trim() === '') {
            if (!faltando.includes(nome))
                faltando.push(nome);
            return inteiro;
        }
        return valor;
    });
    return { texto, faltando, desconhecidas };
}
//# sourceMappingURL=variaveis.js.map